import isEqual from "lodash/isEqual";
import { SourceItem } from "../../shared/models/source-item.model";
import { getBasefilePaths } from "../../shared/utils/basefile.utils";
import { buildCartItem, loadCart, saveCart } from "../../utils/cart.utils";
import { useCallback } from "react";
import { useSiteContext } from "../SiteContext";
import { useFileContext } from "../FileContext";
import { useSystemPropertiesFilter, useValidityFilter } from "../FilterContext";

// Adds the current file to the cart
export const useAddToCart = (): (() => void) => {
    const { fileState } = useFileContext();
    const { siteState } = useSiteContext();
    const validity = useValidityFilter();
    const system = useSystemPropertiesFilter();

    return useCallback(() => {
        const cart = loadCart(siteState.site?.name || "unknown");
        if (fileState.path) {
            const item = buildCartItem(fileState.path, fileState.metadata, validity || "", system || {});
            if (item) {
                if (!cart.find((cartItem: SourceItem) => {
                    return isEqual(cartItem, item);
                })) {
                    const newcart: Array<SourceItem> = [...cart];
                    newcart.push(item);
                    saveCart(newcart, siteState.site?.name || "unknown");
                    // TODO: Feedback to user            
                }
            }
        }
    }, [fileState.path, siteState.site?.name, validity, system, fileState.metadata]);
};

export const useAddToCartEnabled = (): (() => boolean) => {
    const { fileState } = useFileContext();
    const { siteState } = useSiteContext();
    const validity = useValidityFilter();
    const system = useSystemPropertiesFilter();

    return useCallback((): boolean => {

        let enabled = false;
        if (fileState.path) {
            const basefilePaths = getBasefilePaths(siteState.site);
            if (basefilePaths.includes(fileState.path)) {
                return false;
            }
            const item = buildCartItem(fileState.path, fileState.metadata, validity || "", system || {});
            if (item) {
                const cart = loadCart(siteState.site?.name || "unknown");
                enabled = !cart.find((cartItem: SourceItem) => {
                    return isEqual(cartItem, item);
                });
            }
        }

        return enabled;
    }, [
        fileState.path,
        siteState.site,
        validity,
        system,
        fileState.metadata,
    ]);
};
